// @ts-nocheck


import React from 'react';
import InnerForm from '../components/InnerForm';
import { vehicleTariffEnum } from '../../../lib/enum';





export const VehicleTariffTypeForm = ({ vehicleTariffId }) => {
  return (
    <>
      <InnerForm
        vehicleTariffId={vehicleTariffId}
        type={vehicleTariffEnum.byType} />

    </>);

};

export default VehicleTariffTypeForm;
